/* unplugin-vue-components disabled */import script from "./PlagiarizedPoster.vue?vue&type=script&setup=true&lang=js"
export * from "./PlagiarizedPoster.vue?vue&type=script&setup=true&lang=js"

import "./PlagiarizedPoster.vue?vue&type=style&index=0&id=71364514&scoped=true&lang=scss"

import exportComponent from "D:\\pangu_artificial_intelligence_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71364514"]])

export default __exports__